import { Modal } from "bootstrap";

const getModal = (id, show, payload) => {
  const $element = document.getElementById(id);
  // Bug real (auditoría 2026-08-14): sin este guard, un modal que todavía
  // no está montado en el DOM (el componente dueño no llegó a montarlo, o
  // vive condicionalmente en el árbol y no está presente en este momento)
  // crasheaba en setAttribute — todos los callers hacen
  // getModal(id, ...).show()/.hide() a ciegas, sin chequear nada antes. Se
  // devuelve un objeto no-op para que esos callers no rompan.
  if (!$element) {
    console.error(`getModal: no se encontró el elemento #${id}`);
    return { show: () => {}, hide: () => {} };
  }
  $element.setAttribute("data-payload", JSON.stringify(payload));
  return Modal.getInstance($element) || new Modal($element, { show });
};

export default getModal;
